import './ImagePlaceholder.css'

type ImagePlaceholderProps = {
  alt: string
  variant: 'hero' | 'flat-roof' | 'panels' | 'metal' | 'project'
  className?: string
  showLabel?: boolean
}

export default function ImagePlaceholder({ alt, variant, className = '', showLabel = true }: ImagePlaceholderProps) {
  return (
    <div
      role="img"
      aria-label={`${alt}. Image placeholder.`}
      className={`image-placeholder image-placeholder--${variant} relative overflow-hidden ${className}`.trim()}
    >
      <div aria-hidden="true" className="image-placeholder__haze absolute inset-x-0 top-[12%] h-1/5 blur-3xl" />
      <div aria-hidden="true" className="image-placeholder__building absolute -right-[8%] bottom-[12%] h-[58%] w-[72%] shadow-2xl" />
      <div aria-hidden="true" className="image-placeholder__roof absolute -right-[9%] bottom-[60%] h-[16%] w-[76%] -skew-y-6 shadow-xl" />
      <div aria-hidden="true" className="image-placeholder__window absolute right-[13%] bottom-[18%] h-[35%] w-[38%]" />
      <div aria-hidden="true" className="image-placeholder__window-inner absolute right-[16%] bottom-[22%] h-[23%] w-[31%]" />
      <div aria-hidden="true" className="image-placeholder__ground absolute inset-x-0 bottom-0 h-[24%]" />
      {showLabel && (
        <span className="image-placeholder__label absolute bottom-3 left-3 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white">
          Image placeholder
        </span>
      )}
    </div>
  )
}
